export default __webpack_public_path__ + "static/media/med-banner.8aea18c0.png";